import ManageApplication from '../../components/Shelter/Applications/ApplicationManage';
import PageFrame from '../../components/PageFrame';

const ApplicationManagement = () => {
    
    return (
        <PageFrame>
            <ManageApplication />
        </PageFrame>
    );
};

export default ApplicationManagement;